import React, { useEffect, useState } from "react";
import useSWR from "swr";
import { fetcher, optionsFetcher } from "../../components/Overview/Overview";
import { EmployerSpecificTooltip } from "./components/tooltips";

export const CompetenceProfileCard = React.memo((props) => {
    const [UUID, setUUID] = useState(false);
    const [competenceprofileDetail, setCompetenceprofileDetail] = useState(false);

    const { data: getCompetenceProfileDetails } = useSWR(() => (UUID ? `/v1/competenceprofiles/${UUID}/` : false), fetcher);

    useEffect(() => {
        setUUID(props.competenceProfileUUID);
    }, [props.competenceProfileUUID]);

    useEffect(() => {
        if (getCompetenceProfileDetails) {
            setCompetenceprofileDetail(getCompetenceProfileDetails);
        }
    }, [getCompetenceProfileDetails]);

    // Options used in the competence profile filtering
    const { data: competenceprofileDetailOptions } = useSWR(() => "/v1/competenceprofiles/", optionsFetcher);
    const languageOptions = competenceprofileDetailOptions?.actions?.POST?.language?.choices;
    const { data: typeOptions } = useSWR(() => "/v1/competenceprofiletypes/", fetcher);
    const kindOptions = [
        {
            value: "base",
            bool: false,
            display_name: "Basis"
        },
        {
            value: "repetition",
            bool: true,
            display_name: "Herhaling"
        }
    ];

    return (
        <>
            {competenceprofileDetail && (
                <div className="form-section__row row">
                    <div className="col-12">
                        <div className="certificate">
                            <div className="certificate__column">
                                <div>
                                    Je kiest voor de cursus:
                                    <br />
                                    <strong>{competenceprofileDetail.course_name || competenceprofileDetail.name}</strong>
                                    <br />
                                    <br />
                                    {competenceprofileDetail?.certification_name && (
                                        <>
                                            Dit leidt tot de volgende certificering: <br />
                                            <strong>
                                                {competenceprofileDetail?.certification_name
                                                    ? competenceprofileDetail?.certification_name
                                                    : competenceprofileDetail?.name}
                                            </strong>
                                            <br />
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className="certificate__column">
                                Je kiest voor de volgende opties op het competentieprofiel:
                                <dl className={"row definition-list"}>
                                    <div className="col-4">
                                        <dt className={"definition-list__key"}>Type</dt>
                                        <dd className={"definition-list__value"}>
                                            {typeOptions?.results.find((o) => o.slug === competenceprofileDetail?.type)?.name || "-"}
                                        </dd>
                                        <dt className={"definition-list__key"}>E-learning</dt>
                                        <dd className={"definition-list__value"}>{competenceprofileDetail?.contains_elearning ? "Ja" : "Nee"}</dd>
                                    </div>
                                    <div className="col-4">
                                        <dt className={"definition-list__key"}>Soort</dt>
                                        <dd className={"definition-list__value"}>
                                            {kindOptions?.find((o) => o.bool === competenceprofileDetail?.repetition)?.display_name || "-"}
                                        </dd>
                                        <dt className={"definition-list__key"}>Opleiderspecifiek</dt>
                                        <dd className={"definition-list__value"}>{competenceprofileDetail?.trainers?.length > 0 ? "Ja" : "Nee"}</dd>
                                    </div>
                                    <div className="col-4">
                                        <dt className={"definition-list__key"}>Taal</dt>
                                        <dd className={"definition-list__value"}>{competenceprofileDetail?.language?.toUpperCase()}</dd>
                                        <dt className={"definition-list__key"}>
                                            Bedrijfsspecifiek{" "}
                                            <EmployerSpecificTooltip
                                                place="left"
                                                identifier="employer-specific-cp-card"
                                                containerClass={"generic-tooltip--tiny-margin"}
                                            />
                                        </dt>
                                        <dd className={"definition-list__value"}>{competenceprofileDetail?.allow_employer_specific ? "Mogelijk" : "Niet mogelijk"}</dd>
                                    </div>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
});
